import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { userActions } from '../../_actions'
import LoginJSON from './login.json'
import { useNavigate } from 'react-router'
import '../login/Login.css'
import Loader from '../../components/Atoms/Loader'
import Button from '../../components/Atoms/buttons/button'
import { TbEye, TbEyeOff, TbLock, TbMail, TbUser } from 'react-icons/tb'
const Login = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const selector = useSelector(state => state)
  const [fieldsLogin, setFieldsLogin] = useState({ email: '', password: '', employeeId: '' })
  const [errorsLogin, setErrorsLogin] = useState({})
  const [passwordVisible, setPasswordVisible] = useState(false)


  const inputChange = e => {
    e.preventDefault()
    const { name, value } = e.target
    setFieldsLogin(prevState => ({ ...prevState, [name]: value }))
    setErrorsLogin(prevState => ({ ...prevState, [name]: '' }))
  }

  const loginSubmit = e => {
    e.preventDefault()
    if (handleValidationLogin()) {
      const { email, password, employeeId } = fieldsLogin
      dispatch(userActions.login({ email: email, password: password, employeeId: employeeId }, navigate))
    }
  }

  const handleValidationLogin = () => {
    let formIsValid = true
    let errors = {}
    if (!fieldsLogin.email.trim()) {
      formIsValid = false
      errors.email = LoginJSON.ErrorMsg.userNameEmpty
    }
    if (!fieldsLogin.employeeId.trim()) {
      formIsValid = false
      errors.employeeId = LoginJSON.ErrorMsg.employeeIdEmpty
    } else if (fieldsLogin.employeeId.length < 10 || fieldsLogin.employeeId.length > 15) {
      formIsValid = false
      errors.employeeId = LoginJSON.ErrorMsg.employeeIdShort
    }
    if (!fieldsLogin.password.trim()) {
      formIsValid = false
      errors.password = LoginJSON.ErrorMsg.passwordEmpty
    } else if (fieldsLogin.password.length < 6) {
      formIsValid = false
      errors.password = LoginJSON.ErrorMsg.passwordShort
    }
    setErrorsLogin(errors)
    return formIsValid
  }

  const togglePasswordVisibility = () => {
    setPasswordVisible(prevState => !prevState)
  }
  return (
    <>
      <Loader loading={selector?.users?.loading || false} />

      <div className='flex items-center justify-center h-screen bg-[#F9F9FC]'>
        <div className='bg-white  p-8 border border-[#C9C9C9] rounded-xl shadow-lg md:w-[500px] w-11/12'>
          <div className='pb-3 space-y-6'>
            <div>
              <img src='/sidebarimage.png' alt='' />
            </div>
            <div>
              <h2 className='text-[#000000] md:text-3xl text-xl font-bold'>
                Login to PKRD Admin Panel
              </h2>
            </div>
          </div>
          <form className='space-y-4'>
            <div className='space-y-2'>
              <label
                htmlFor='email'
                className='text-sm font-medium text-gray-700'
              >
                Employee ID
              </label>
              <div className='relative flex items-center border border-[#D2D2D2] bg-transparent rounded-lg space-x-2 p-2'>
                <TbUser color='' />
                <input
                  type='text'
                  id='employeeId'
                  name='employeeId'
                  placeholder='Enter Employee Id'
                  className={`w-full  text-gray-900 focus:outline-none  ${errorsLogin['employeeId'] ? 'border-red-500' : ''
                    }`}
                  onChange={inputChange}
                  aria-invalid={!!errorsLogin['employeeId']}
                  aria-describedby='employeeIdError'
                />
              </div>
              {errorsLogin['employeeId'] && (
                <div id='employeeIdError' className='mt-1 text-xs text-red-500'>
                  {errorsLogin['employeeId']}
                </div>
              )}
            </div>
            <div className='space-y-2'>
              <label
                htmlFor='email'
                className='text-sm font-medium text-gray-700'
              >
                Email
              </label>
              <div className='relative flex items-center border border-[#D2D2D2] bg-transparent rounded-lg space-x-2 p-2'>
                <TbMail color='' />
                <input
                  id='email'
                  name='email'
                  type='text'
                  placeholder='Enter your email address'
                  className={`w-full  text-gray-900 focus:outline-none  ${errorsLogin['email'] ? 'border-red-500' : ''
                    }`}
                  onChange={inputChange}
                  aria-invalid={!!errorsLogin['email']}
                  aria-describedby='userNameError'
                />
              </div>

              {errorsLogin['email'] && (
                <div id='userNameError' className='mt-1 text-xs text-red-500'>
                  {errorsLogin['email']}
                </div>
              )}
            </div>
            <div className='space-y-2'>
              <label
                htmlFor='password'
                className='text-sm font-medium text-gray-700'
              >
                Password
              </label>
              <div className='relative flex items-center border border-[#D2D2D2] bg-transparent rounded-lg space-x-2 p-2'>
                <TbLock />
                <input
                  id='password'
                  name='password'
                  type={passwordVisible ? 'text' : 'password'}
                  placeholder='Enter your password'
                  className={`w-full  text-gray-900 focus:outline-none ${errorsLogin['password'] ? 'border-red-500' : ''
                    }`}
                  onChange={inputChange}
                  aria-invalid={!!errorsLogin['password']}
                  aria-describedby='passwordError'
                />

                <button
                  type='button'
                  onClick={togglePasswordVisibility}
                  className='text-gray-300 focus:outline-none'
                >
                  {passwordVisible ? (
                    <span className='text-sm text-neutral-500'>
                      {' '}
                      <TbEyeOff size={15} />{' '}
                    </span>
                  ) : (
                    <span className='text-sm text-neutral-500'>
                      {' '}
                      <TbEye size={15} />
                    </span>
                  )}
                </button>
              </div>

              {errorsLogin['password'] && (
                <div id='passwordError' className='mt-1 text-xs text-red-500'>
                  {errorsLogin['password']}
                </div>
              )}
            </div>

            <div className='flex justify-center w-full py-4'>
              <Button type='submit' onClick={loginSubmit}>
                {LoginJSON.signin}
              </Button>
            </div>
          </form>
        </div>
      </div>

      {/* <div className='lg:flex font-[poppins]'> 
        <div className='hidden lg:flex items-center justify-center bg-[#15A14A] flex-1 h-screen'>
          <div className='max-w-xs duration-200 transform cursor-pointer hover:scale-110'>
            <img className='w-5/6 mx-auto' src='/logo-png 1.png' alt='Logo' />
          </div>
        </div>
 
        <div className='lg:w-1/2 '>
          <div className='py-12 bg-[#15A14A] lg:text-[#15A14A] text-[#fff] lg:bg-white flex justify-center lg:justify-start lg:px-8'>
            <div className='flex items-center cursor-pointer'>
              <div>
                <img
                  className='w-24 mx-auto'
                  src='/logo-png 1.png'
                  alt='Logo'
                />
              </div>
              <div className='ml-2 text-2xl font-semibold tracking-wide'>
                PKRD
              </div>
            </div>
          </div>
 
          <div className='w-2/3 mx-auto my-auto'>
            <div className='py-10 space-y-2'>
              <h2 className='text-2xl font-bold lg:text-3xl'>
                {LoginJSON.messageWeLCome}
              </h2>
              <h2 className='text-xl font-bold lg:text-2xl'>
                {' '}
                {LoginJSON.heading}
              </h2>
            </div>
            <form className=''>
              <div className='w-full space-y-6'>
                <div className='relative'>
                  <label
                    htmlFor='email'
                    className='text-sm font-medium text-gray-700'
                  >
                    User Name
                  </label>
                  <div className='relative'>
                    <FaUserLock className='absolute text-green-700 transform -translate-y-1/2 left-3 top-1/2' />
                    <input
                      id='email'
                      name='email'
                      type='text'
                      placeholder='Enter your user name'
                      className={`w-full pl-10 pr-4 py-2  text-gray-900 focus:outline-none border-b border-neutral-700 ${
                        errorsLogin['email'] ? 'border-red-500' : ''
                      }`}
                      onChange={inputChange}
                      aria-invalid={!!errorsLogin['email']}
                      aria-describedby='userNameError'
                    />
                  </div>

                  {errorsLogin['email'] && (
                    <div
                      id='userNameError'
                      className='mt-1 text-xs text-red-500'
                    >
                      {errorsLogin['email']}
                    </div>
                  )}
                </div>
                <div className='relative py-4'>
                  <label
                    htmlFor='password'
                    className='text-sm font-medium text-gray-700'
                  >
                    Password
                  </label>
                  <div className='relative'>
                    <FaLock className='absolute text-green-700 transform -translate-y-1/2 left-3 top-1/2' />
                    <input
                      id='password'
                      name='password'
                      type={passwordVisible ? 'text' : 'password'}
                      placeholder='Enter your password'
                      className={`w-full pl-10 pr-12 py-2 border-b border-neutral-700 bg-white text-gray-900  focus:outline-none ${
                        errorsLogin['password'] ? 'border-red-500' : ''
                      }`}
                      onChange={inputChange}
                      aria-invalid={!!errorsLogin['password']}
                      aria-describedby='passwordError'
                    />

                    <button
                      type='button'
                      onClick={togglePasswordVisibility}
                      className='absolute text-gray-300 transform -translate-y-1/2 right-3 top-1/2 focus:outline-none'
                    >
                      {passwordVisible ? (
                        <span className='text-sm text-neutral-500'>
                          {' '}
                          <FaEyeSlash size={15} />{' '}
                        </span>
                      ) : (
                        <span className='text-sm text-neutral-500'>
                          {' '}
                          <FaEye size={15} />
                        </span>
                      )}
                    </button>
                  </div>

                  {errorsLogin['password'] && (
                    <div
                      id='passwordError'
                      className='mt-1 text-xs text-red-500'
                    >
                      {errorsLogin['password']}
                    </div>
                  )}
                </div>

                <div className='flex justify-center w-full py-4'>
                  <Button type='submit' onClick={loginSubmit}>
                    {LoginJSON.signin}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div> */}
    </>
  )
}

export default Login
